module.exports = __webpack_public_path__ + "img/baiwan-1-en.344dbdc7.webp";